import { Duration, Temporal } from '@js-joda/core';
export class TimeRange {
    constructor(start, end) {
        this.start = start;
        this.end = end;
    }
    get duration() {
        return Duration.between(this.start, this.end);
    }
    /**
     * Returns `true` if this range contains the given time.
     *
     * This is inclusive of start only.
     */
    contains(time) {
        return this.start.compareTo(time) <= 0 && time.compareTo(this.end) < 0;
    }
    /**
     * Returns `true` if this range encloses the given range.
     *
     * This is inclusive of start and end.
     */
    encloses(other) {
        return this.start.compareTo(other.start) <= 0 && other.end.compareTo(this.end) <= 0;
    }
    /**
     * Returns `true` if this range is equal to the given range.
     */
    equals(other) {
        return this.start.equals(other.start) && this.end.equals(other.end);
    }
    /**
     * Returns `true` if this range is after the given time or range.
     */
    isAfter(timeOrTimeRange) {
        return timeOrTimeRange instanceof Temporal
            ? this.start.compareTo(timeOrTimeRange) > 0
            : this.start.compareTo(timeOrTimeRange.end) >= 0 && !timeOrTimeRange.equals(this);
    }
    /**
     * Returns `true` if this range is before the given time or range.
     */
    isBefore(timeOrTimeRange) {
        return timeOrTimeRange instanceof Temporal
            ? this.end.compareTo(timeOrTimeRange) <= 0 && this.start.compareTo(timeOrTimeRange) < 0
            : this.end.compareTo(timeOrTimeRange.start) <= 0 && !timeOrTimeRange.equals(this);
    }
    /**
     * Returns `true` if this range overlaps the given range.
     */
    overlaps(other) {
        return other.equals(this) || (this.start.compareTo(other.end) < 0 && other.start.compareTo(this.end) < 0);
    }
    /**
     * Returns this range as a string.
     */
    toString() {
        return this.start.toString() + TimeRange.separator + this.end.toString();
    }
}
TimeRange.separator = '/';
